module.exports = __webpack_public_path__ + "img/son.aafd517c.svg";